var swiperObserver = {
    init: function() {
        const swipers = document.querySelectorAll('.swiper');

        let addedDocuments = null;
        if (sessionStorage.vuex) addedDocuments = JSON.parse(sessionStorage.vuex).addedDocuments;

        const swiperOptions = {
            treshold: 0
        }

        function swiperIntersection(entries) {
            entries.map((entry) => {
                if(entry.isIntersecting) {
                    const nextBtn = entry.target.querySelector(".swiper-button-next");
                    if(nextBtn) // TODO: Figure out why this is necessary and fix it
                        nextBtn.classList.remove("swiper-button-disabled", "swiper-button-lock");

                    const swiperImages = entry.target.querySelectorAll(".lazy");
                    if(swiperImages) // TODO: Figure out why this is necessary and fix it
                        swiperImages.forEach(el => el.classList.add('lazy--show'));


                    const btns = entry.target.querySelectorAll("[data-favoriteid]");
                    if(addedDocuments !== null && btns) {
                        btns.forEach(function (btn) {
                            const btnFaveId = btn.dataset.favoriteid;
                            btn.addEventListener("click", function () {
                                const favoriteId = document.getElementById("favoriteId");
                                favoriteId.value = btnFaveId;
                                var change = new Event('change');
                                favoriteId.dispatchEvent(change);
                            })
                            if (addedDocuments.includes(parseInt(btnFaveId))) btn.classList.add('in-list');
                        });
                    }

                    swiperObservers.unobserve(entry.target);
                }
            })
        }

        const swiperObservers = new IntersectionObserver(swiperIntersection, swiperOptions);
        swipers.forEach(el => swiperObservers.observe(el));
    }
}

export default swiperObserver;